module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Lamp2-544926da8d3e5fbcc08b6aea5bf25ed8.svg";